export default function searchMenu() {
  const searchModalOpen = document.querySelectorAll('.site-search-toggle svg');

  searchModalOpen.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      document.documentElement.classList.add('search-modal-active');

      if (event.target.closest('div').classList.contains('mobile-nav-search-toggle')) {
        const realInput = document.querySelector('.modal-header--form input[type="text"]');
        const dummyInput = document.querySelector('.mobile-nav-search input[type="search"]');
        realInput.value = dummyInput.value;
        dummyInput.value = '';
        realInput.dispatchEvent(new KeyboardEvent('input', {}));
      }

      setTimeout(() => {
        document.getElementById('input-focus').focus();
      }, 100);
    });
  });
}
